<template>
    <div class="relative min-h-screen min-w-screen bg-white text-gray-900 flex flex-col items-center justify-center overflow-hidden">
        <div v-if="returnImages.length > 0" class="flex flex-col align-middle justify-center items-center my-20 gap-8 md:my-14">
            <div class="mx-4 text-center gap-2">
                <div class="font-black text-3xl md:text-5xl">Your new company logo</div>
                <div class="mt-4 italic text-gray-500 text-xl md:text-2xl">Choose one or download all 4</div>
            </div>
            <div class="grid grid-cols-1 sm:grid-cols-2">
                <div v-for="(url, index) in returnImages" :key="index" class="justify-center items-center flex flex-col pt-10 gap-4">
                    <img :src="url" class="w-4/5 h-auto border-white shadow-lg sm:w-1/2" :alt="`Generated Logo ${index + 1}`" />
                    <a :href="url" :download="`generated-logo-${index + 1}.png`"
                       class="w-3/4 max-w-[180px] min-h-3 shadow-xl transition ease-in-out text-white uppercase bg-[#0079E3]/80 py-2 px-4 justify-center items-center flex text-nowrap hover:scale-105">
                        Download Logo {{ index + 1 }}
                    </a>
                </div>
            </div>
        </div>
        <div v-else class="font-black text-3xl text-center px-2 md:text-5xl">
            No logos generated yet...
        </div>
    </div>
</template>

<script>
export default {
    name: 'results',
    data() {
        return {
            returnImages: [],
        };
    },
    created() {
        // Handle multiple query params correctly
        const queryreturnImages = this.$route.query.imageUrl;

        // Vue will treat multiple query params with the same name as an array
        if (queryreturnImages) {
            // If only one URL is passed, ensure it's an array
            this.returnImages = Array.isArray(queryreturnImages) ? queryreturnImages : [queryreturnImages];
        }
    }
};
</script>